// extracted by mini-css-extract-plugin
export default {"container":"RoleForm_container__zxaZ5","body":"RoleForm_body__ORsYo","buttonCancel":"RoleForm_buttonCancel__bDC9q","checkMobile":"RoleForm_checkMobile__ROPng"};